import moment from 'moment';
import { map, get } from 'lodash';
import { withRouter } from 'react-router';
import { compose, lifecycle, withState, withProps, branch, renderComponent, renderNothing } from 'recompose';

import { getReceipt } from '../../receipt/actions';
import Loader from '../../components/Loader';
import { formatDuration } from '../../utils/helpers';
import { getAppLinks, getShopAddress } from '../utils';

const formatBrand = (rawBrand) => {
  const nonGenericCards = ['mastercard', 'visa', 'discover', 'americanexpress'];
  const brand = (rawBrand || '').replace(/\s/g, '').toLowerCase();

  if (nonGenericCards.includes(brand)) {
    return brand;
  }

  return 'generic';
};

const getService = (appt) => {
  const service = map(appt.appointment_service, 'name').join(', ');
  if (service.length > 20) {
    return `${service.slice(0, 20)}...`;
  }
  return service;
};

const getDate = (appt, shop) => {
  const timezone = shop.timezone;
  const date = moment.utc(appt.dateTime).tz(timezone).format('ddd, MMM Do');
  const startTime = moment.utc(appt.dateTime).tz(timezone).format('h:mm A');
  return `${date}, ${startTime}`;
};

export default compose(
  withRouter,
  withState('busy', 'setBusy', true),
  withState('receipt', 'setReceipt', null),
  lifecycle({
    async componentDidMount() {
      try {
        const receipt = await getReceipt(this.props.params.id, this.props.params.transactionId);
        this.props.setReceipt(receipt);
      } finally {
        this.props.setBusy(false);
      }
    },
  }),
  branch(
    props => props.busy,
    renderComponent(Loader),
  ),
  branch(
    props => !props.receipt,
    renderNothing,
  ),
  withProps(({ receipt, params }) => {
    const { shop } = receipt;
    const confirmationCode = get(receipt, 'appointments[0].confirmationCode', '');
    return {
      shop,
      address: getShopAddress(shop),
      phone: shop.phone,
      logo: shop.logo,
      transactionId: params.transactionId,
      ...getAppLinks(params.brandRoute, confirmationCode),
      receipt: {
        ...receipt,
        brand: formatBrand(receipt.brand),
        date: moment(receipt.createdAt).format('MM/DD/YYYY'),
        datetime: moment(receipt.createdAt).format('hh:mm:ss A'),
        appointments: map(receipt.appointments, appt => ({
          confirmationCode: appt.confirmationCode,
          customerName: appt.customer.firstName,
          barberName: `${appt.barber.firstName} ${(appt.barber.lastName || '')[0]}`,
          service: getService(appt),
          date: getDate(appt, shop),
          duration: formatDuration(appt.duration),
          barber: appt.barber,
        })),
      },
      squireInfoClassName: shop.mobileAppCta ? 'c-phones-background__content' : 'u-mt-15',
    };
  }),
);



// WEBPACK FOOTER //
// ./src/app/notifications/hoc/withReceiptNotification.js